export const FORM_SECTION_TYPES = {
  PLANS: 'plans',
  JOURNAL: 'journal',
  PROFILE: 'profile',
  SCHEDULE: 'schedule',
  LIBRARY: 'library',
  GRADE: 'grade'
}

export const FORM_SECTION_INNER_TYPE = {
  ADD: 'add',
  VISIT: 'visit',
  UPDATE: 'update',
  DELETE: 'delete',
  IMPORT: 'import',
  COPY: 'copy',
  EDIT: 'edit',
}

export const FORM_FORM_TYPE = {
  PLAN: 'plan',
  MATERIALS: 'materials',
  TASKS: 'tasks',
  TESTS: 'tests',
  LESSON: 'lesson',
  HOME_WORK: 'home_work',
  INDIVIDUAL: 'individual',
  BALL: 'ball',
  THEME: 'theme',
  INDIVIDUAL_LESSON: 'individualLesson',
  LESSON_THEME: 'lessonTheme',
  BALL_VISIT: 'ballVisit',
  BALL_ONLY: 'ballOnly',
  INCENTIVE_POINT: 'incentivePoint',
  PASS: 'pass',
  EXAM: 'exam',
  LESSON_PASS_EXAM: 'lessonPassExam',
  SETTINGS: 'settings',
  ORGANIZATION_CURATOR: 'organization_curator',
  ORGANIZATION_PLACE: 'organization_place',
  PERIOD: 'period',
  PRACTICE_MARK: 'practice_mark',
  TEACHER: 'teacher',
}

export const PLANS_API = {
  [`${FORM_SECTION_INNER_TYPE.ADD}_${FORM_FORM_TYPE.PLAN}`]: 'plan_add_lesson_v1',
  [`${FORM_SECTION_INNER_TYPE.UPDATE}_${FORM_FORM_TYPE.PLAN}`]: 'plan_update_lesson_v1',

  [`${FORM_SECTION_INNER_TYPE.ADD}_${FORM_FORM_TYPE.MATERIALS}`]: 'plan_add_material_v1',
  [`${FORM_SECTION_INNER_TYPE.UPDATE}_${FORM_FORM_TYPE.MATERIALS}`]: 'plan_update_material_v1',

  [`${FORM_SECTION_INNER_TYPE.ADD}_${FORM_FORM_TYPE.TASKS}`]: 'plan_add_task_v1',
  [`${FORM_SECTION_INNER_TYPE.UPDATE}_${FORM_FORM_TYPE.TASKS}`]: 'plan_update_task_v1',

  [`${FORM_SECTION_INNER_TYPE.ADD}_${FORM_FORM_TYPE.TESTS}`]: 'plan_add_test_v1',
  [`${FORM_SECTION_INNER_TYPE.UPDATE}_${FORM_FORM_TYPE.TESTS}`]: 'plan_update_test_v1',

  [`${FORM_SECTION_INNER_TYPE.IMPORT}_${FORM_FORM_TYPE.LESSON}`]: 'plan_import_lesson_v1',
  [`${FORM_SECTION_INNER_TYPE.COPY}_${FORM_FORM_TYPE.LESSON}`]: 'plan_copy_lesson_v1',

  [`${FORM_SECTION_INNER_TYPE.IMPORT}_${FORM_FORM_TYPE.TESTS}`]: 'sdot_import_test_v1',

}

export const JOURNAL_API = {
  [`${FORM_SECTION_INNER_TYPE.ADD}_${FORM_FORM_TYPE.LESSON}`]: 'grade_add_lesson_v1',

  [`${FORM_SECTION_INNER_TYPE.ADD}_${FORM_FORM_TYPE.INDIVIDUAL_LESSON}`]: 'grade_add_individualLesson_v1',
}

export const FILE_FORM_API = {
  FILE: 'https://s3.sdot.kz/upload',
  EXCEL: `${process.env.REACT_APP_URL}/edu/import-lesson`
}
